import { CommonModule } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonService } from '../Model/Common/common.service';
import { Subject } from 'rxjs';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { ComboService } from '../Model/Combo/combo.service';
import { ToastService, toastTypeEnum } from '../Util/Toast/toast.service';
import { LoaderComponent } from '../Component/Loader/loader/loader.component';
import { AllotmentDetailService } from '../allotment-detail.service';
import { SessionService } from '../Util/Session/session.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EmployeeFilterComponent } from '../employee-filter/employee-filter.component';

@Component({
  selector: 'app-allotment-history-report',
  standalone: true,
  imports: [CommonModule, FormsModule, DataTablesModule, LoaderComponent],
  templateUrl: './allotment-history-report.component.html',
  styleUrl: './allotment-history-report.component.scss'
})
export class AllotmentHistoryReportComponent {

  EmpCode = '';
  EmpName = '';
  isDisabled: boolean = false;
  EmpMasterID = 0;
  TableData = [] as any
  user: any;
  dtoptions: DataTables.Settings = {};
  constructor(
    public common: CommonService,
    private comboload: ComboService,
    private toast: ToastService,
    private allotment: AllotmentDetailService,
    private session: SessionService,
    private modalService: NgbModal
  ) {
    this.user = this.session.GetUserDetails();
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit() {

  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }
  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;

  AllotmentHistory() {
    this.isDisabled = true;
    this.allotment.allotmentHistoryReport({
      ReportName: 'EmpAllotHistoryReport',
      BranchID: 0,
      MonthName: new Date().toLocaleString('default', { month: 'long' }),
      YearName: new Date().getFullYear(),
      Compliance: 'Compliance',
      EmpMasterID: this.EmpMasterID,
      LoginUserID: this.user.UserId,
      EmpType: 'FRONT',
      AsOnDate: ''
    }).subscribe({
      next: (response) => {
        this.TableData = response.Table;
        if(this.TableData.length == 0){
          this.toast.show({ message: 'No data found', type: toastTypeEnum.warning });
        }
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);
        });
      },
      complete: () => {
        this.isDisabled = false;
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ComboLoad(Combotype: String) {
    if(this.EmpCode.trim() == ''){
      this.toast.show({ message: 'Enter Employee Code', type: toastTypeEnum.warning });
      return;
    }

    this.isDisabled = true;
    this.comboload.ComboLoad({
      'Combotype': Combotype,
      'UserType': 'A',
      'BranchId': 0,
      'ClientId': 0,
      'SiteId': 0,
      'EmpType': 'front',
      'EmpCode': this.EmpCode
    }).subscribe({
      next: (response) => {
        if (response.ComboLoad) {
          if (Combotype == 'EmpLoadForRegularization') {
            if (response.ComboLoad.length == 0) {
              this.EmpMasterID = 0;
              this.EmpName = '';
              this.TableData = [];
              this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
                dtInstance.destroy();
                this.dtTrigger.next(null);
              });
              this.toast.show({ message: 'Invalid Employee Code', type: toastTypeEnum.warning });
              this.isDisabled = false;
              return;
            }
            const data = response.ComboLoad[0];
            this.EmpMasterID = data.EmpMasterID;
            this.EmpName = data.Name;
            this.AllotmentHistory();
          }
        }
      },
      complete: () => {
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  excelDownload() {
    if (this.TableData.length > 0) {
      this.common.ExcelDump('Allotment History Report', this.TableData);
    } else {
      this.toast.show({ message: 'No Data Found', type: toastTypeEnum.warning });
    }
  }

  FilterEmployee(){
    const modalRef = this.modalService.open(EmployeeFilterComponent, {
      centered: true,
      backdrop: 'static',
      size: 'lg'
    })

    modalRef.result.then((result) => {
      this.EmpCode = result.EmpCode;
      this.EmpMasterID = result.EmpMasterID;
      this.EmpName = result.Name;
      this.AllotmentHistory();
    })
  }
}
